module.exports = __webpack_public_path__ + "static/media/skill.f3734ad1.png";